
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="p" components={components}>{`Der weltweite Aufstieg von rechten und linken Populisten ist das prägende politische Merkmal der Gegenwart. Deren Logik ist einfach: Auf der einen Seite das «Volk» und auf der anderen Seite die «Eliten».`}</MDXTag>
<MDXTag name="p" components={components}>{`Unser interaktives Quiz verrät Ihnen, wie populistisch Sie selbst eingestellt sind. `}<a href='#methodik'><i className='ui angle double down icon' />{`Mehr zur Methodik finden Sie hier.`}</a></MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  